import React from "react";
import {Colors} from "../colors";

interface IconEmptyCheckProps {
  color?: string;
  width?: number;
  height?: number;
}

export const IconEmptyCheck = ({width = 18, height = 14, color = Colors.green._900}: IconEmptyCheckProps) => {
  return (
    <svg width={width} height={height} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M20 6L9 17L4 12" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};
